export const STORE_STATUS_LABELS: Record<string, string> = {
  pending: 'Pendiente de confirmación',
  pending_payment: 'Pago pendiente',
  assigned: 'En preparación',
  paid: 'Pago confirmado',
  completed: 'Completado',
  fulfilled: 'Entregado',
  cancelled: 'Cancelado',
  ready_for_pickup: 'Listo para retirar',
  shipping_in_progress: 'En envío',
};

export const DISPATCH_STATUS_LABELS: Record<string, string> = {
  none: 'Repartidor aún no convocado',
  not_published: 'No publicado para cadetes',
  published: 'Convocando cadete',
  taken: 'Tomado por cadete',
  picked_up: 'Retirado por cadete',
  in_progress: 'En camino',
  on_the_way: 'En camino',
  arrived: 'Cadete en destino',
  completed: 'Completado',
  delivered: 'Entregado por cadete',
  cancelled: 'Cancelado (envío)',
};

export const STORE_STATUS_SETTING_OPTIONS = [
  'pending',
  'paid',
  'assigned',
  'ready_for_pickup',
  'shipping_in_progress',
  'fulfilled',
  'cancelled',
] as const;

export const DISPATCH_STATUS_SETTING_OPTIONS = [
  'not_published',
  'published',
  'taken',
  'picked_up',
  'delivered',
  'cancelled',
] as const;

export const normalizeStatusKey = (status: unknown): string => {
  const raw = String(status || '').trim();
  if (!raw) return '';
  return raw
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase();
};

export const normalizeDispatchStatusKey = (status: unknown): string => {
  const key = normalizeStatusKey(status);
  if (!key) return 'none';

  const compact = key.replace(/_/g, '');
  const aliases: Record<string, string> = {
    null: 'none',
    undefined: 'none',
    no_status: 'none',
    inprogress: 'in_progress',
    ontheway: 'on_the_way',
    pickedup: 'picked_up',
    notpublished: 'not_published',
    assigning: 'published',
    assigningcourier: 'published',
    complete: 'completed',
  };

  return aliases[key] || aliases[compact] || key;
};

export const getStoreStatusLabel = (status: unknown): string => {
  const key = normalizeStatusKey(status);
  return STORE_STATUS_LABELS[key] || 'En proceso';
};

export const getDispatchStatusLabel = (status: unknown): string => {
  const key = normalizeDispatchStatusKey(status);
  if (key === 'none') return DISPATCH_STATUS_LABELS.none;
  return DISPATCH_STATUS_LABELS[key] || 'En gestión';
};

export const getStoreStatusProgress = (status: unknown): number => {
  const key = normalizeStatusKey(status);
  const progressByStatus: Record<string, number> = {
    pending: 15,
    pending_payment: 25,
    paid: 35,
    assigned: 50,
    ready_for_pickup: 70,
    shipping_in_progress: 85,
    fulfilled: 100,
    completed: 100,
    cancelled: 100,
  };

  return progressByStatus[key] ?? 20;
};

export const getDispatchStatusProgress = (status: unknown): number => {
  const key = normalizeDispatchStatusKey(status);
  const progressByStatus: Record<string, number> = {
    none: 5,
    not_published: 15,
    published: 30,
    taken: 50,
    picked_up: 65,
    in_progress: 80,
    on_the_way: 80,
    arrived: 90,
    delivered: 100,
    completed: 100,
    cancelled: 100,
  };

  return progressByStatus[key] ?? 10;
};
